import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _ai-c _gap-2" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h2" }
const _hoisted_3 = { class: "_tc--base _mb-3 gfu-bt--b1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_processing_button = _resolveComponent("processing-button")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, {
    huge: "",
    class: "_tac"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_3, _toDisplayString($props.description), 1 /* TEXT */),
        _createVNode(_component_processing_button, {
          "is-processing": $props.isProcessing,
          theme: $props.buttonTheme,
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('action')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.buttonLabel), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["is-processing", "theme"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}